export const RECEIVE_BANK_ACCOUNTS = "RECEIVE_BANK_ACCOUNTS";
export const RECEIVE_BANKS = "RECEIVE_BANKS";



// WEBPACK FOOTER //
// ./src/features/banks/actionTypes.js